interface Category {
  id?: number;
  name?: string;
  categoryOwner?: string;
  companyId?: number;
}

export const newCategory = (): Category => {
  return {};
};

export default Category;
